// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"f2863b82","665":"68e4b565","706":"cc727622","949":"74d080b4"}[chunkId] + ".chunk.js";
};